export default {
    namespaced: true,
    state: {
        grupo:{},
        dialogEditar: false
    },
    mutations: {
        SET_GRUPO(state, grupo){
            state.grupo = grupo;
        },
        SET_DIALOGEDITAR(state, mostrar){
            state.dialogEditar = mostrar;
        }
    },
    actions: {
        setGrupo({commit}, grupo){
            commit('SET_GRUPO', grupo);
        },
        setDialogEditar({commit}, mostrar){
            commit('SET_DIALOGEDITAR', mostrar);
        }
    }
}